/** Contexto do aparelho para decidir qual convite mostrar (sem React). */
import { isIos, isStandalone } from '@/pwa/pwaEnvironment';

export type InstallPlatform = 'ios' | 'android' | 'desktop';
export type InstallBrowser = 'ios-safari' | 'ios-other' | 'android' | 'in-app' | 'desktop';

export function getPlatform(ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''): InstallPlatform {
  if (isIos()) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
}

export function isInAppBrowser(ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''): boolean {
  return /FBAN|FBAV|FB_IAB|Instagram|WhatsApp|Line\/|; wv\)/i.test(ua);
}

export function getBrowser(ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''): InstallBrowser {
  const platform = getPlatform(ua);
  if (platform === 'desktop') return 'desktop';
  if (isInAppBrowser(ua)) return 'in-app';
  if (platform === 'android') return 'android';
  return /CriOS|FxiOS|EdgiOS|OPiOS/.test(ua) ? 'ios-other' : 'ios-safari';
}

export function isMobile(): boolean {
  return getPlatform() !== 'desktop';
}

export function deviceLabel(): string {
  const b = getBrowser();
  const p = getPlatform();
  return `${p}:${b}`;
}

export { isStandalone };
